export default {
    FREQUENCIA: 1,
    TURNO: 2
}